import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import ChangePasswordModal from './ChangePasswordModal';
import './DashboardLayout.css';

const DashboardLayout = () => {
  const [showChangePwd, setShowChangePwd] = useState(false);

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <main className="main-content">
        <header className="topbar">
          <input
            className="search-input"
            type="text"
            placeholder="🔍  Ara..."
          />
          <div className="topbar-actions">
            <button className="change-pwd-btn" onClick={() => setShowChangePwd(true)}>
              Şifre Değiştir
            </button>
            <button className="logout-btn" onClick={() => {
              localStorage.removeItem('token');
              window.location.href = '/login';
            }}>
              Çıkış Yap
            </button>
          </div>
        </header>
        <div className="page-content">
          <Outlet />
        </div>
      </main>

      {showChangePwd && <ChangePasswordModal onClose={() => setShowChangePwd(false)} />}
    </div>
  );
};

export default DashboardLayout;